import {
  GithubIcon_default
} from "./chunk-3KRRKZ3D.mjs";
export {
  GithubIcon_default as default
};
